/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Sales
 * Это Sales api сервер, для запросов от Frontend.  Для запросов требуется указать header с Authorization и типом Bearer.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Order } from './Order'
import {
  OrderFromJSON,
  OrderFromJSONTyped,
  OrderToJSON,
  OrderToJSONTyped,
} from './Order'
import type { ResponseEnterpriseGetListMeta } from './ResponseEnterpriseGetListMeta'
import {
  ResponseEnterpriseGetListMetaFromJSON,
  ResponseEnterpriseGetListMetaFromJSONTyped,
  ResponseEnterpriseGetListMetaToJSON,
  ResponseEnterpriseGetListMetaToJSONTyped,
} from './ResponseEnterpriseGetListMeta'

/**
 *
 * @export
 * @interface ResponseOrderGetList
 */
export interface ResponseOrderGetList {
  /**
   *
   * @type {boolean}
   * @memberof ResponseOrderGetList
   */
  success: boolean
  /**
   *
   * @type {Array<Order>}
   * @memberof ResponseOrderGetList
   */
  data?: Array<Order>
  /**
   *
   * @type {ResponseEnterpriseGetListMeta}
   * @memberof ResponseOrderGetList
   */
  meta?: ResponseEnterpriseGetListMeta
  /**
   *
   * @type {string}
   * @memberof ResponseOrderGetList
   */
  errorMessage?: string
  /**
   *
   * @type {number}
   * @memberof ResponseOrderGetList
   */
  codeError?: number
}

/**
 * Check if a given object implements the ResponseOrderGetList interface.
 */
export function instanceOfResponseOrderGetList(
  value: object,
): value is ResponseOrderGetList {
  if (!('success' in value) || value['success'] === undefined) return false
  return true
}

export function ResponseOrderGetListFromJSON(json: any): ResponseOrderGetList {
  return ResponseOrderGetListFromJSONTyped(json, false)
}

export function ResponseOrderGetListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseOrderGetList {
  if (json == null) {
    return json
  }
  return {
    success: json['success'],
    data:
      json['data'] == null
        ? undefined
        : (json['data'] as Array<any>).map(OrderFromJSON),
    meta:
      json['meta'] == null
        ? undefined
        : ResponseEnterpriseGetListMetaFromJSON(json['meta']),
    errorMessage:
      json['errorMessage'] == null ? undefined : json['errorMessage'],
    codeError: json['codeError'] == null ? undefined : json['codeError'],
  }
}

export function ResponseOrderGetListToJSON(json: any): ResponseOrderGetList {
  return ResponseOrderGetListToJSONTyped(json, false)
}

export function ResponseOrderGetListToJSONTyped(
  value?: ResponseOrderGetList | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value
  }

  return {
    success: value['success'],
    data:
      value['data'] == null
        ? undefined
        : (value['data'] as Array<any>).map(OrderToJSON),
    meta: ResponseEnterpriseGetListMetaToJSON(value['meta']),
    errorMessage: value['errorMessage'],
    codeError: value['codeError'],
  }
}
